module.exports = __webpack_public_path__ + "static/media/No_Assignment_Types.d2548c92.svg";